import { useQuery, UseQueryOptions } from 'react-query';

import { Guid, OptOut } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useDataRoomUserOptOutDetailsQuery(
	guid: Guid | undefined,
	dataRoomUserGuid: Guid | null | undefined,
	options?: Omit<UseQueryOptions<OptOut, unknown, OptOut, any>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.DataRoomUsers.OptOut(guid, dataRoomUserGuid),
		() =>
			AxiosUtils.getResponseData<OptOut>(
				api.get(CerebroApiEndpoints.DataRoomUsers.OptOutDetail(guid, dataRoomUserGuid))
			),
		options
	);
}
